import React from "react";

export const withInfiniteScroll = conditionFn => Component =>
  class WithInfiniteScroll extends React.Component {
    componentDidMount() {
      window.addEventListener("scroll", this.onScroll, false);
    }

    componentWillUnmount() {
      window.removeEventListener("scroll", this.onScroll, false);
    }

    onScroll = () => conditionFn(this.props) && this.props.onPaginatedSearch();

    render() {
      return <Component {...this.props} />;
    }
  };



// WEBPACK FOOTER //
// ./src/components/hoc/withInfiniteScroll.js